import React from 'react'
import { Box, Link,Typography} from '@mui/material';
import footerLogoUrl from  "../../images/RBIS-footer-logo.png";
const targetUrl = "https://apparelsolutions.averydennison.com/en";

const Newfooter = () => {
  // --- The outer <div> has been removed ---
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#e0e0e0',
        color: '#555',
        pt: 4, 
        pb: 2, 
      }}
    >
      <Box 
        sx={{ 
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: { xs: 'center', md: 'flex-end' }, 
          flexDirection: { xs: 'column', md: 'row' },
          textAlign: { xs: 'center', md: 'left' },
          px: '40px', // Matches header padding
        }}
      >
        {/* ====== Left Side: Logo & Copyright ====== */}
        <Box sx={{ mb: { xs: 3, md: 0 } }}>
          <Box
            component="img"
            src={footerLogoUrl}
            alt="Avery Dennison Logo"
            sx={{
              height: 45,
              width: 'auto',
              mb: 1.5,
            }}
          />
          <Typography variant="body2" sx={{ color: '#555' }}>
            © 2014 Avery Dennison Corporation
          </Typography>
        </Box>

        {/* ====== Right Side: Navigation Links ====== */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 2, sm: 3 },
          }}
        >
          <Link
            href={targetUrl}
            color="inherit"
            underline="hover"
            target="_blank" 
            rel="noopener noreferrer"
            sx={{ fontSize: '0.9rem', fontWeight: 500 }}
          >
            Legal & Privacy Notices
          </Link>
         
          <Link
            href={targetUrl}
            color="inherit"
            underline="hover"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontSize: '0.9rem', fontWeight: 500 }}
          >
            Terms & Conditions
          </Link>
         
          <Link
            href={targetUrl}
            color="inherit"
            underline="hover"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontSize: '0.9rem', fontWeight: 500 }}
          >
            Contact Us
          </Link>
        </Box>
      </Box>
    </Box>
  )
}

export default Newfooter